// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Manrope-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v2.2.17 | MIT License | https://tailwindcss.com *//*! modern-normalize v1.1.0 | MIT License | https://github.com/sindresorhus/modern-normalize */

/*
Document
========
*/

/**
Use a better box model (opinionated).
*/

*,
::before,
::after {
	box-sizing: border-box;
}

/**
Use a more readable tab size (opinionated).
*/

html {
	-moz-tab-size: 4;
	-o-tab-size: 4;
	   tab-size: 4;
}

/**
1. Correct the line height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
*/

html {
	line-height: 1.15; /* 1 */
	-webkit-text-size-adjust: 100%; /* 2 */
}

/*
Sections
========
*/

/**
Remove the margin in all browsers.
*/

body {
	margin: 0;
}

/**
Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)
*/

body {
	font-family:
		system-ui,
		-apple-system, /* Firefox supports this but not yet \`system-ui\` */
		'Segoe UI',
		Roboto,
		Helvetica,
		Arial,
		sans-serif,
		'Apple Color Emoji',
		'Segoe UI Emoji';
}

/*
Grouping content
================
*/

/**
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
*/

hr {
	height: 0; /* 1 */
	color: inherit; /* 2 */
}

/*
Text-level semantics
====================
*/

/**
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr[title] {
	-webkit-text-decoration: underline dotted;
	        text-decoration: underline dotted;
}

/**
Add the correct font weight in Edge and Safari.
*/

b,
strong {
	font-weight: bolder;
}

/**
1. Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)
2. Correct the odd 'em' font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
	font-family:
		ui-monospace,
		SFMono-Regular,
		Consolas,
		'Liberation Mono',
		Menlo,
		monospace; /* 1 */
	font-size: 1em; /* 2 */
}

/**
Add the correct font size in all browsers.
*/

small {
	font-size: 80%;
}

/**
Prevent 'sub' and 'sup' elements from affecting the line height in all browsers.
*/

sub,
sup {
	font-size: 75%;
	line-height: 0;
	position: relative;
	vertical-align: baseline;
}

sub {
	bottom: -0.25em;
}

sup {
	top: -0.5em;
}

/*
Tabular data
============
*/

/**
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
*/

table {
	text-indent: 0; /* 1 */
	border-color: inherit; /* 2 */
}

/*
Forms
=====
*/

/**
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
*/

button,
input,
optgroup,
select,
textarea {
	font-family: inherit; /* 1 */
	font-size: 100%; /* 1 */
	line-height: 1.15; /* 1 */
	margin: 0; /* 2 */
}

/**
Remove the inheritance of text transform in Edge and Firefox.
1. Remove the inheritance of text transform in Firefox.
*/

button,
select { /* 1 */
	text-transform: none;
}

/**
Correct the inability to style clickable types in iOS and Safari.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
	-webkit-appearance: button;
}

/**
Remove the inner border and padding in Firefox.
*/

::-moz-focus-inner {
	border-style: none;
	padding: 0;
}

/**
Restore the focus styles unset by the previous rule.
*/

:-moz-focusring {
	outline: 1px dotted ButtonText;
}

/**
Remove the additional ':invalid' styles in Firefox.
See: https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737
*/

:-moz-ui-invalid {
	box-shadow: none;
}

/**
Remove the padding so developers are not caught out when they zero out 'fieldset' elements in all browsers.
*/

legend {
	padding: 0;
}

/**
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
	vertical-align: baseline;
}

/**
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
	height: auto;
}

/**
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
	-webkit-appearance: textfield; /* 1 */
	outline-offset: -2px; /* 2 */
}

/**
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
	-webkit-appearance: none;
}

/**
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to 'inherit' in Safari.
*/

::-webkit-file-upload-button {
	-webkit-appearance: button; /* 1 */
	font: inherit; /* 2 */
}

/*
Interactive
===========
*/

/*
Add the correct display in Chrome and Safari.
*/

summary {
	display: list-item;
}/**
 * Manually forked from SUIT CSS Base: https://github.com/suitcss/base
 * A thin layer on top of normalize.css that provides a starting point more
 * suitable for web applications.
 */

/**
 * Removes the default spacing and border for appropriate elements.
 */

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

button {
  background-color: transparent;
  background-image: none;
}

fieldset {
  margin: 0;
  padding: 0;
}

ol,
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

/**
 * Tailwind custom reset styles
 */

/**
 * 1. Use the user's configured \`sans\` font-family (with Tailwind's default
 *    sans-serif font stack as a fallback) as a sane default.
 * 2. Use Tailwind's default "normal" line-height so the user isn't forced
 *    to override it to ensure consistency even when using the default theme.
 */

html {
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 1 */
  line-height: 1.5; /* 2 */
}


/**
 * Inherit font-family and line-height from \`html\` so users can set them as
 * a class directly on the \`html\` element.
 */

body {
  font-family: inherit;
  line-height: inherit;
}

/**
 * 1. Prevent padding and border from affecting element width.
 *
 *    We used to set this in the html element and inherit from
 *    the parent element for everything else. This caused issues
 *    in shadow-dom-enhanced elements like <details> where the content
 *    is wrapped by a div with box-sizing set to \`content-box\`.
 *
 *    https://github.com/mozdevs/cssremedy/issues/4
 *
 *
 * 2. Allow adding a border to an element by just adding a border-width.
 *
 *    By default, the way the browser specifies that an element should have no
 *    border is by setting it's border-style to \`none\` in the user-agent
 *    stylesheet.
 *
 *    In order to easily add borders to elements by just setting the \`border-width\`
 *    property, we change the default border-style for all elements to \`solid\`, and
 *    use border-width to hide them instead. This way our \`border\` utilities only
 *    need to set the \`border-width\` property instead of the entire \`border\`
 *    shorthand, making our border utilities much more straightforward to compose.
 *
 *    https://github.com/tailwindcss/tailwindcss/pull/116
 */

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

/*
 * Ensure horizontal rules are visible by default
 */

hr {
  border-top-width: 1px;
}

/**
 * Undo the \`border-style: none\` reset that Normalize applies to images so that
 * our \`border-{width}\` utilities have the expected effect.
 *
 * The Normalize reset is unnecessary for us since we default the border-width
 * to 0 on all elements.
 *
 * https://github.com/tailwindcss/tailwindcss/issues/362
 */

img {
  border-style: solid;
}

textarea {
  resize: vertical;
}

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1;
  color: #9ca3af;
}

input::placeholder,
textarea::placeholder {
  opacity: 1;
  color: #9ca3af;
}

button,
[role="button"] {
  cursor: pointer;
}

/**
 * Override legacy focus reset from Normalize with modern Firefox focus styles.
 *
 * This is actually an improvement over the new defaults in Firefox in our testing,
 * as it triggers the better focus styles even for links, which still use a dotted
 * outline in Firefox by default.
 */
 
:-moz-focusring {
	outline: auto;
}

table {
  border-collapse: collapse;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/**
 * Reset links to optimize for opt-in styling instead of
 * opt-out.
 */

a {
  color: inherit;
  text-decoration: inherit;
}

/**
 * Reset form element properties that are easy to forget to
 * style explicitly so you don't inadvertently introduce
 * styles that deviate from your design system. These styles
 * supplement a partial reset that is already applied by
 * normalize.css.
 */

button,
input,
optgroup,
select,
textarea {
  padding: 0;
  line-height: inherit;
  color: inherit;
}

/**
 * Use the configured 'mono' font family for elements that
 * are expected to be rendered with a monospace font, falling
 * back to the system monospace stack if there is no configured
 * 'mono' font family.
 */

pre,
code,
kbd,
samp {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

/**
 * 1. Make replaced elements \`display: block\` by default as that's
 *    the behavior you want almost all of the time. Inspired by
 *    CSS Remedy, with \`svg\` added as well.
 *
 *    https://github.com/mozdevs/cssremedy/issues/14
 * 
 * 2. Add \`vertical-align: middle\` to align replaced elements more
 *    sensibly by default when overriding \`display\` by adding a
 *    utility like \`inline\`.
 *
 *    This can trigger a poorly considered linting error in some
 *    tools but is included by design.
 * 
 *    https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210
 */

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/**
 * Constrain images and videos to the parent width and preserve
 * their intrinsic aspect ratio.
 *
 * https://github.com/mozdevs/cssremedy/issues/14
 */

img,
video {
  max-width: 100%;
  height: auto;
}

/**
 * Ensure the default browser behavior of the \`hidden\` attribute.
 */

[hidden] {
  display: none;
}

*, ::before, ::after {
	--tw-translate-x: 0;
	--tw-translate-y: 0;
	--tw-rotate: 0;
	--tw-skew-x: 0;
	--tw-skew-y: 0;
	--tw-scale-x: 1;
	--tw-scale-y: 1;
	--tw-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
	--tw-border-opacity: 1;
	border-color: rgba(229, 231, 235, var(--tw-border-opacity));
	--tw-ring-offset-shadow: 0 0 #0000;
	--tw-ring-shadow: 0 0 #0000;
	--tw-shadow: 0 0 #0000;
	--tw-blur: var(--tw-empty,/*!*/ /*!*/);
	--tw-brightness: var(--tw-empty,/*!*/ /*!*/);
	--tw-contrast: var(--tw-empty,/*!*/ /*!*/);
	--tw-grayscale: var(--tw-empty,/*!*/ /*!*/);
	--tw-hue-rotate: var(--tw-empty,/*!*/ /*!*/);
	--tw-invert: var(--tw-empty,/*!*/ /*!*/);
	--tw-saturate: var(--tw-empty,/*!*/ /*!*/);
	--tw-sepia: var(--tw-empty,/*!*/ /*!*/);
	--tw-drop-shadow: var(--tw-empty,/*!*/ /*!*/);
	--tw-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
	--tw-backdrop-blur: var(--tw-empty,/*!*/ /*!*/);
	--tw-backdrop-brightness: var(--tw-empty,/*!*/ /*!*/);
	--tw-backdrop-contrast: var(--tw-empty,/*!*/ /*!*/);
	--tw-backdrop-grayscale: var(--tw-empty,/*!*/ /*!*/);
	--tw-backdrop-hue-rotate: var(--tw-empty,/*!*/ /*!*/);
	--tw-backdrop-invert: var(--tw-empty,/*!*/ /*!*/);
	--tw-backdrop-opacity: var(--tw-empty,/*!*/ /*!*/);
	--tw-backdrop-saturate: var(--tw-empty,/*!*/ /*!*/);
	--tw-backdrop-sepia: var(--tw-empty,/*!*/ /*!*/);
	--tw-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.container {
	width: 100%;
}
@media (min-width: 640px) {

	.container {
		max-width: 640px;
	}
}
@media (min-width: 768px) {

	.container {
		max-width: 768px;
	}
}
@media (min-width: 1024px) {

	.container {
		max-width: 1024px;
	}
}
@media (min-width: 1280px) {

	.container {
		max-width: 1280px;
	}
}
@media (min-width: 1536px) {

	.container {
		max-width: 1536px;
	}
}
.visible {
	visibility: visible;
}
.fixed {
	position: fixed;
}
.absolute {
	position: absolute;
}
.relative {
	position: relative;
}
.inset-0 {
	top: 0px;
	right: 0px;
	bottom: 0px;
	left: 0px;
}
.z-\\[1\\] {
	z-index: 1;
}
.z-10 {
	z-index: 10;
}
.float-right {
	float: right;
}
.m-3 {
	margin: 0.75rem;
}
.m-auto {
	margin: auto;
}
.m-0 {
	margin: 0px;
}
.m-4 {
	margin: 1rem;
}
.mx-3 {
	margin-left: 0.75rem;
	margin-right: 0.75rem;
}
.my-auto {
	margin-top: auto;
	margin-bottom: auto;
}
.mx-auto {
	margin-left: auto;
	margin-right: auto;
}
.my-4 {
	margin-top: 1rem;
	margin-bottom: 1rem;
}
.my-2 {
	margin-top: 0.5rem;
	margin-bottom: 0.5rem;
}
.mx-\\[-1rem\\] {
	margin-left: -1rem;
	margin-right: -1rem;
}
.mx-6 {
	margin-left: 1.5rem;
	margin-right: 1.5rem;
}
.my-3 {
	margin-top: 0.75rem;
	margin-bottom: 0.75rem;
}
.my-8 {
	margin-top: 2rem;
	margin-bottom: 2rem;
}
.mx-5 {
	margin-left: 1.25rem;
	margin-right: 1.25rem;
}
.mx-4 {
	margin-left: 1rem;
	margin-right: 1rem;
}
.mx-8 {
	margin-left: 2rem;
	margin-right: 2rem;
}
.my-5 {
	margin-top: 1.25rem;
	margin-bottom: 1.25rem;
}
.mb-7 {
	margin-bottom: 1.75rem;
}
.mt-14 {
	margin-top: 3.5rem;
}
.ml-3 {
	margin-left: 0.75rem;
}
.mt-5 {
	margin-top: 1.25rem;
}
.mb-3 {
	margin-bottom: 0.75rem;
}
.mt-1 {
	margin-top: 0.25rem;
}
.mt-2 {
	margin-top: 0.5rem;
}
.mb-10 {
	margin-bottom: 2.5rem;
}
.mt-6 {
	margin-top: 1.5rem;
}
.mb-1 {
	margin-bottom: 0.25rem;
}
.mt-8 {
	margin-top: 2rem;
}
.mb-4 {
	margin-bottom: 1rem;
}
.mt-12 {
	margin-top: 3rem;
}
.ml-4 {
	margin-left: 1rem;
}
.ml-5 {
	margin-left: 1.25rem;
}
.mt-10 {
	margin-top: 2.5rem;
}
.mt-16 {
	margin-top: 4rem;
}
.mt-7 {
	margin-top: 1.75rem;
}
.ml-\\[10\\%\\] {
	margin-left: 10%;
}
.ml-24 {
	margin-left: 6rem;
}
.mt-40 {
	margin-top: 10rem;
}
.mt-0 {
	margin-top: 0px;
}
.mt-9 {
	margin-top: 2.25rem;
}
.ml-3\\.5 {
	margin-left: 0.875rem;
}
.mt-20 {
	margin-top: 5rem;
}
.mb-6 {
	margin-bottom: 1.5rem;
}
.mt-44 {
	margin-top: 11rem;
}
.mt-4 {
	margin-top: 1rem;
}
.mr-8 {
	margin-right: 2rem;
}
.mr-6 {
	margin-right: 1.5rem;
}
.mb-8 {
	margin-bottom: 2rem;
}
.block {
	display: block;
}
.inline-block {
	display: inline-block;
}
.inline {
	display: inline;
}
.flex {
	display: flex;
}
.table {
	display: table;
}
.table-row {
	display: table-row;
}
.grid {
	display: grid;
}
.list-item {
	display: list-item;
}
.hidden {
	display: none;
}
.h-\\[0\\.34rem\\] {
	height: 0.34rem;
}
.h-full {
	height: 100%;
}
.h-\\[90\\%\\] {
	height: 90%;
}
.h-8 {
	height: 2rem;
}
.h-4 {
	height: 1rem;
}
.h-\\[30vh\\] {
	height: 30vh;
}
.h-px {
	height: 1px;
}
.h-screen {
	height: 100vh;
}
.h-\\[100vh\\] {
	height: 100vh;
}
.h-16 {
	height: 4rem;
}
.h-2 {
	height: 0.5rem;
}
.h-\\[426px\\] {
	height: 426px;
}
.h-10 {
	height: 2.5rem;
}
.h-40 {
	height: 10rem;
}
.min-h-\\[80vh\\] {
	min-height: 80vh;
}
.min-h-screen {
	min-height: 100vh;
}
.\\!min-h-full {
	min-height: 100% !important;
}
.w-\\[1\\.42rem\\] {
	width: 1.42rem;
}
.w-full {
	width: 100%;
}
.w-\\[40\\%\\] {
	width: 40%;
}
.w-\\[10\\%\\] {
	width: 10%;
}
.w-\\[10vw\\] {
	width: 10vw;
}
.w-\\[80\\%\\] {
	width: 80%;
}
.w-1\\/2 {
	width: 50%;
}
.w-2\\/3 {
	width: 66.666667%;
}
.\\!w-full {
	width: 100% !important;
}
.w-min {
	width: -moz-min-content;
	width: min-content;
}
.w-screen {
	width: 100vw;
}
.w-4\\/5 {
	width: 80%;
}
.w-3\\/5 {
	width: 60%;
}
.w-44 {
	width: 11rem;
}
.w-1\\/3 {
	width: 33.333333%;
}
.w-\\[33\\%\\] {
	width: 33%;
}
.w-\\[60px\\] {
	width: 60px;
}
.w-\\[17px\\] {
	width: 17px;
}
.w-\\[62\\%\\] {
	width: 62%;
}
.w-2 {
	width: 0.5rem;
}
.w-\\[38\\%\\] {
	width: 38%;
}
.w-3\\/4 {
	width: 75%;
}
.w-\\[843px\\] {
	width: 843px;
}
.w-\\[131px\\] {
	width: 131px;
}
.w-3 {
	width: 0.75rem;
}
.w-\\[31\\%\\] {
	width: 31%;
}
.w-\\[178px\\] {
	width: 178px;
}
.w-\\[69\\%\\] {
	width: 69%;
}
.w-\\[32\\%\\] {
	width: 32%;
}
.w-\\[68\\%\\] {
	width: 68%;
}
.w-\\[199px\\] {
	width: 199px;
}
.w-8 {
	width: 2rem;
}
.w-\\[25vw\\] {
	width: 25vw;
}
.w-1\\/12 {
	width: 8.333333%;
}
.w-36 {
	width: 9rem;
}
.w-1\\/4 {
	width: 25%;
}
.w-\\[25rem\\] {
	width: 25rem;
}
.min-w-\\[4rem\\] {
	min-width: 4rem;
}
.\\!min-w-\\[10\\%\\] {
	min-width: 10% !important;
}
.max-w-full {
	max-width: 100%;
}
.max-w-\\[1067px\\] {
	max-width: 1067px;
}
.max-w-\\[398px\\] {
	max-width: 398px;
}
.max-w-3xl {
	max-width: 48rem;
}
.flex-1 {
	flex: 1 1 0%;
}
.flex-auto {
	flex: 1 1 auto;
}
.flex-\\[0_0_100\\%\\] {
	flex: 0_0_100%;
}
.flex-shrink-0 {
	flex-shrink: 0;
}
.flex-grow {
	flex-grow: 1;
}
.table-fixed {
	table-layout: fixed;
}
.border-collapse {
	border-collapse: collapse;
}
.transform {
	transform: var(--tw-transform);
}
.cursor-pointer {
	cursor: pointer;
}
.select-none {
	-webkit-user-select: none;
	   -moz-user-select: none;
	        user-select: none;
}
.resize {
	resize: both;
}
.list-inside {
	list-style-position: inside;
}
.list-disc {
	list-style-type: disc;
}
.list-decimal {
	list-style-type: decimal;
}
.\\!list-disc {
	list-style-type: disc !important;
}
.flex-row {
	flex-direction: row;
}
.flex-row-reverse {
	flex-direction: row-reverse;
}
.flex-col {
	flex-direction: column;
}
.flex-wrap {
	flex-wrap: wrap;
}
.items-start {
	align-items: flex-start;
}
.items-end {
	align-items: flex-end;
}
.items-center {
	align-items: center;
}
.justify-center {
	justify-content: center;
}
.justify-between {
	justify-content: space-between;
}
.justify-evenly {
	justify-content: space-evenly;
}
.gap-5 {
	gap: 1.25rem;
}
.gap-1\\.5 {
	gap: 0.375rem;
}
.gap-1 {
	gap: 0.25rem;
}
.gap-2\\.5 {
	gap: 0.625rem;
}
.gap-2 {
	gap: 0.5rem;
}
.gap-3 {
	gap: 0.75rem;
}
.gap-4 {
	gap: 1rem;
}
.gap-y-2 {
	row-gap: 0.5rem;
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.self-start {
	align-self: flex-start;
}
.self-end {
	align-self: flex-end;
}
.self-center {
	align-self: center;
}
.self-stretch {
	align-self: stretch;
}
.overflow-hidden {
	overflow: hidden;
}
.whitespace-nowrap {
	white-space: nowrap;
}
.rounded {
	border-radius: 0.25rem;
}
.rounded-2xl {
	border-radius: 1rem;
}
.rounded-xl {
	border-radius: 0.75rem;
}
.rounded-3xl {
	border-radius: 1.5rem;
}
.rounded-\\[35px\\] {
	border-radius: 35px;
}
.rounded-md {
	border-radius: 0.375rem;
}
.rounded-\\[31px\\] {
	border-radius: 31px;
}
.rounded-full {
	border-radius: 9999px;
}
.rounded-\\[98\\.436px\\] {
	border-radius: 98.436px;
}
.rounded-\\[2\\.25rem\\] {
	border-radius: 2.25rem;
}
.border {
	border-width: 1px;
}
.border-2 {
	border-width: 2px;
}
.border-solid {
	border-style: solid;
}
.border-red-500 {
	--tw-border-opacity: 1;
	border-color: rgba(239, 68, 68, var(--tw-border-opacity));
}
.border-gray-300 {
	--tw-border-opacity: 1;
	border-color: rgba(209, 213, 219, var(--tw-border-opacity));
}
.border-black {
	--tw-border-opacity: 1;
	border-color: rgba(0, 0, 0, var(--tw-border-opacity));
}
.bg-transparent {
	background-color: transparent;
}
.bg-white {
	--tw-bg-opacity: 1;
	background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.bg-gray-200 {
	--tw-bg-opacity: 1;
	background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}
.bg-red-50 {
	--tw-bg-opacity: 1;
	background-color: rgba(254, 242, 242, var(--tw-bg-opacity));
}
.bg-indigo-600 {
	--tw-bg-opacity: 1;
	background-color: rgba(79, 70, 229, var(--tw-bg-opacity));
}
.bg-gray-400 {
	--tw-bg-opacity: 1;
	background-color: rgba(156, 163, 175, var(--tw-bg-opacity));
}
.bg-gray-100 {
	--tw-bg-opacity: 1;
	background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}
.bg-opacity-80 {
	--tw-bg-opacity: 0.8;
}
.bg-opacity-20 {
	--tw-bg-opacity: 0.2;
}
.object-cover {
	-o-object-fit: cover;
	   object-fit: cover;
}
.p-0 {
	padding: 0px;
}
.p-8 {
	padding: 2rem;
}
.p-4 {
	padding: 1rem;
}
.px-2 {
	padding-left: 0.5rem;
	padding-right: 0.5rem;
}
.py-1 {
	padding-top: 0.25rem;
	padding-bottom: 0.25rem;
}
.px-8 {
	padding-left: 2rem;
	padding-right: 2rem;
}
.py-4 {
	padding-top: 1rem;
	padding-bottom: 1rem;
}
.px-4 {
	padding-left: 1rem;
	padding-right: 1rem;
}
.px-\\[12\\%\\] {
	padding-left: 12%;
	padding-right: 12%;
}
.px-11 {
	padding-left: 2.75rem;
	padding-right: 2.75rem;
}
.py-6 {
	padding-top: 1.5rem;
	padding-bottom: 1.5rem;
}
.px-10 {
	padding-left: 2.5rem;
	padding-right: 2.5rem;
}
.py-5 {
	padding-top: 1.25rem;
	padding-bottom: 1.25rem;
}
.py-2 {
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
}
.px-20 {
	padding-left: 5rem;
	padding-right: 5rem;
}
.py-12 {
	padding-top: 3rem;
	padding-bottom: 3rem;
}
.py-8 {
	padding-top: 2rem;
	padding-bottom: 2rem;
}
.py-11 {
	padding-top: 2.75rem;
	padding-bottom: 2.75rem;
}
.py-9 {
	padding-top: 2.25rem;
	padding-bottom: 2.25rem;
}
.px-9 {
	padding-left: 2.25rem;
	padding-right: 2.25rem;
}
.px-12 {
	padding-left: 3rem;
	padding-right: 3rem;
}
.px-5 {
	padding-left: 1.25rem;
	padding-right: 1.25rem;
}
.px-64 {
	padding-left: 16rem;
	padding-right: 16rem;
}
.py-7 {
	padding-top: 1.75rem;
	padding-bottom: 1.75rem;
}
.px-6 {
	padding-left: 1.5rem;
	padding-right: 1.5rem;
}
.pt-6 {
	padding-top: 1.5rem;
}
.pb-2 {
	padding-bottom: 0.5rem;
}
.pr-4 {
	padding-right: 1rem;
}
.pt-4 {
	padding-top: 1rem;
}
.pr-20 {
	padding-right: 5rem;
}
.pl-10 {
	padding-left: 2.5rem;
}
.pr-6 {
	padding-right: 1.5rem;
}
.pt-28 {
	padding-top: 7rem;
}
.pb-12 {
	padding-bottom: 3rem;
}
.pl-6 {
	padding-left: 1.5rem;
}
.pr-12 {
	padding-right: 3rem;
}
.\\!pt-4 {
	padding-top: 1rem !important;
}
.pl-5 {
	padding-left: 1.25rem;
}
.pl-4 {
	padding-left: 1rem;
}
.text-center {
	text-align: center;
}
.align-middle {
	vertical-align: middle;
}
.align-bottom {
	vertical-align: bottom;
}
.text-lg {
	font-size: 1.125rem;
	line-height: 1.75rem;
}
.text-4xl {
	font-size: 2.25rem;
	line-height: 2.5rem;
}
.text-sm {
	font-size: 0.875rem;
	line-height: 1.25rem;
}
.text-base {
	font-size: 1rem;
	line-height: 1.5rem;
}
.text-2xl {
	font-size: 1.5rem;
	line-height: 2rem;
}
.text-6xl {
	font-size: 3.75rem;
	line-height: 1;
}
.text-xl {
	font-size: 1.25rem;
	line-height: 1.75rem;
}
.text-5xl {
	font-size: 3rem;
	line-height: 1;
}
.text-7xl {
	font-size: 4.5rem;
	line-height: 1;
}
.font-medium {
	font-weight: 500;
}
.font-semibold {
	font-weight: 600;
}
.font-bold {
	font-weight: 700;
}
.font-extrabold {
	font-weight: 800;
}
.font-light {
	font-weight: 300;
}
.font-normal {
	font-weight: 400;
}
.\\!font-bold {
	font-weight: 700 !important;
}
.uppercase {
	text-transform: uppercase;
}
.lowercase {
	text-transform: lowercase;
}
.capitalize {
	text-transform: capitalize;
}
.italic {
	font-style: italic;
}
.not-italic {
	font-style: normal;
}
.leading-\\[114\\%\\] {
	line-height: 114%;
}
.leading-\\[117\\%\\] {
	line-height: 117%;
}
.leading-7 {
	line-height: 1.75rem;
}
.leading-\\[60px\\] {
	line-height: 60px;
}
.leading-5 {
	line-height: 1.25rem;
}
.leading-\\[59\\.95px\\] {
	line-height: 59.95px;
}
.leading-9 {
	line-height: 2.25rem;
}
.leading-10 {
	line-height: 2.5rem;
}
.leading-\\[80\\.16px\\] {
	line-height: 80.16px;
}
.leading-4 {
	line-height: 1rem;
}
.leading-\\[70px\\] {
	line-height: 70px;
}
.leading-relaxed {
	line-height: 1.625;
}
.text-gray-700 {
	--tw-text-opacity: 1;
	color: rgba(55, 65, 81, var(--tw-text-opacity));
}
.text-red-600 {
	--tw-text-opacity: 1;
	color: rgba(220, 38, 38, var(--tw-text-opacity));
}
.text-\\[\\#5148FA\\] {
	--tw-text-opacity: 1;
	color: rgba(81, 72, 250, var(--tw-text-opacity));
}
.text-indigo-600 {
	--tw-text-opacity: 1;
	color: rgba(79, 70, 229, var(--tw-text-opacity));
}
.text-white {
	--tw-text-opacity: 1;
	color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.text-gray-500 {
	--tw-text-opacity: 1;
	color: rgba(107, 114, 128, var(--tw-text-opacity));
}
.text-green-600 {
	--tw-text-opacity: 1;
	color: rgba(5, 150, 105, var(--tw-text-opacity));
}
.text-blue-500 {
	--tw-text-opacity: 1;
	color: rgba(59, 130, 246, var(--tw-text-opacity));
}
.underline {
	text-decoration: underline;
}
.shadow {
	--tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
	box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
	--tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
	box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.filter {
	filter: var(--tw-filter);
}
.backdrop-blur-\\[26\\.874555587768555px\\] {
	--tw-backdrop-blur: blur(26.874555587768555px);
	-webkit-backdrop-filter: var(--tw-backdrop-filter);
	        backdrop-filter: var(--tw-backdrop-filter);
}

@font-face {
  font-family: Manrope;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 100 900;
  font-stretch: 50% 200%;
}

@font-face {
  font-family: Poppins;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: 500;
}

:root {
  --primary: #514BFF;
  --on-primary: #FFFFFF;
  --secondary: #FFA96F;
  --on-secondary: #FFFFFF;
  --background-color: #FFFFFF;
  --background-color-dark: #F2F2F2;
  --background-color-darker: #EBEBEB;
  --text-color: #1E1E1E; 
  --text-color-alt: #1E1E1E99;
  --text-color-grey: #777777;
  --input-field-color: #F2F2F2;
  --alt-button-color: #F6F6F6;
  --black-button-color: #130F26;
  --grey: #C8C8C8;
}



html * {
  font-family: Manrope, Arial;
  font-size: 1rem;
  color: var(--text-color)
}

input[type=text], input[type=password], select {
  width: 20.875rem;
  height: 3.3125rem;
  flex-shrink: 0;
  border-radius: 0.875rem; 
  background: var(--background-color-dark);
  font-weight: 600;
  box-sizing: border-box;
  padding: 1rem 1.31rem 0.94rem 1.31rem;
}

h1 {
  font-size: 1.5rem;
  font-weight: 600;
}

h4 {
  font-weight: 500;
}

.grey {
  color: var(--text-color-grey);
}


input[type=text]::-moz-placeholder, input[type=password]::-moz-placeholder {
  color: var(--text-color-alt);
  font-weight: 400;

}


input[type=text]::placeholder, input[type=password]::placeholder {
  color: var(--text-color-alt);
  font-weight: 400;

}

input[type="checkbox"] {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.375rem; 
  flex-shrink: 0;
  color: var(--background-color-dark);
  accent-color: var(--primary);
}

a:link.always-active, a:visited.always-active {
  color: var(--primary);
  font-weight: 600;
}

.heading {
  font-weight: 600;
  font-size: 20px;
}

.focus\\:border-indigo-500:focus {
	--tw-border-opacity: 1;
	border-color: rgba(99, 102, 241, var(--tw-border-opacity));
}

.focus\\:ring-indigo-500:focus {
	--tw-ring-opacity: 1;
	--tw-ring-color: rgba(99, 102, 241, var(--tw-ring-opacity));
}

`, "",{"version":3,"sources":["webpack://./src/components/styles/global.css","webpack://./src/components/styles/%3Cinput%20css%203%3E","webpack://./src/components/styles/%3Cinput%20css%204%3E","<no source>"],"names":[],"mappings":"AAAA,iEAAc,CAAd,8FAAc;;AAAd;;;CAAc;;AAAd;;CAAc;;AAAd;;;CCcC,sBAAsB;ADdT;;AAAd;;CAAc;;AAAd;CCsBC,gBAAgB;CAChB,cAAW;IAAX,WAAW;ADvBE;;AAAd;;;CAAc;;AAAd;CCgCC,iBAAiB,EAAE,MAAM;CACzB,8BAA8B,EAAE,MAAM;ADjCzB;;AAAd;;;CAAc;;AAAd;;CAAc;;AAAd;CC8CC,SAAS;AD9CI;;AAAd;;CAAc;;AAAd;CCsDC;;;;;;;;;kBASiB;AD/DJ;;AAAd;;;CAAc;;AAAd;;;CAAc;;AAAd;CC6EC,SAAS,EAAE,MAAM;CACjB,cAAc,EAAE,MAAM;AD9ET;;AAAd;;;CAAc;;AAAd;;CAAc;;AAAd;CC2FC,yCAAiC;SAAjC,iCAAiC;AD3FpB;;AAAd;;CAAc;;AAAd;;CCoGC,mBAAmB;ADpGN;;AAAd;;;CAAc;;AAAd;;;;CCgHC;;;;;;WAMU,EAAE,MAAM;CAClB,cAAc,EAAE,MAAM;ADvHT;;AAAd;;CAAc;;AAAd;CC+HC,cAAc;AD/HD;;AAAd;;CAAc;;AAAd;;CCwIC,cAAc;CACd,cAAc;CACd,kBAAkB;CAClB,wBAAwB;AD3IX;;AAAd;CC+IC,eAAe;AD/IF;;AAAd;CCmJC,WAAW;ADnJE;;AAAd;;;CAAc;;AAAd;;;CAAc;;AAAd;CCiKC,cAAc,EAAE,MAAM;CACtB,qBAAqB,EAAE,MAAM;ADlKhB;;AAAd;;;CAAc;;AAAd;;;CAAc;;AAAd;;;;;CCoLC,oBAAoB,EAAE,MAAM;CAC5B,eAAe,EAAE,MAAM;CACvB,iBAAiB,EAAE,MAAM;CACzB,SAAS,EAAE,MAAM;ADvLJ;;AAAd;;;CAAc;;AAAd;SCgMS,MAAM;CACd,oBAAoB;ADjMP;;AAAd;;CAAc;;AAAd;;;;CC4MC,0BAA0B;AD5Mb;;AAAd;;CAAc;;AAAd;CCoNC,kBAAkB;CAClB,UAAU;ADrNG;;AAAd;;CAAc;;AAAd;CC6NC,8BAA8B;AD7NjB;;AAAd;;;CAAc;;AAAd;CCsOC,gBAAgB;ADtOH;;AAAd;;CAAc;;AAAd;CC8OC,UAAU;AD9OG;;AAAd;;CAAc;;AAAd;CCsPC,wBAAwB;ADtPX;;AAAd;;CAAc;;AAAd;;CC+PC,YAAY;AD/PC;;AAAd;;;CAAc;;AAAd;CCwQC,6BAA6B,EAAE,MAAM;CACrC,oBAAoB,EAAE,MAAM;ADzQf;;AAAd;;CAAc;;AAAd;CCiRC,wBAAwB;ADjRX;;AAAd;;;CAAc;;AAAd;CC0RC,0BAA0B,EAAE,MAAM;CAClC,aAAa,EAAE,MAAM;AD3RR;;AAAd;;;CAAc;;AAAd;;CAAc;;AAAd;CCwSC,kBAAkB;ADxSL,CAAd;;;;EAAc;;AAAd;;EAAc;;AAAd;;;;;;;;;;;;;EEuBE,SAAS;AFvBG;;AAAd;EE2BE,6BAA6B;EAC7B,sBAAsB;AF5BV;;AAAd;EEgCE,SAAS;EACT,UAAU;AFjCE;;AAAd;;EEsCE,gBAAgB;EAChB,SAAS;EACT,UAAU;AFxCE;;AAAd;;EAAc;;AAAd;;;;;EAAc;;AAAd;EEuDE,4NAAsP,EAAE,MAAM;EAC9P,gBAAgB,EAAE,MAAM;AFxDZ;;;AAAd;;;EAAc;;AAAd;EEkEE,oBAAoB;EACpB,oBAAoB;AFnER;;AAAd;;;;;;;;;;;;;;;;;;;;;;;;EAAc;;AAAd;;;EEmGE,sBAAsB,EAAE,MAAM;EAC9B,eAAe,EAAE,MAAM;EACvB,mBAAmB,EAAE,MAAM;EAC3B,0BAA0B,EAAE,MAAM;AFtGtB;;AAAd;;EAAc;;AAAd;EE8GE,qBAAqB;AF9GT;;AAAd;;;;;;;;EAAc;;AAAd;EE4HE,mBAAmB;AF5HP;;AAAd;EEgIE,gBAAgB;AFhIJ;;AAAd;EEqIE,UAAU;EACV,cAAwC;AFtI5B;;AAAd;;EEqIE,UAAU;EACV,cAAwC;AFtI5B;;AAAd;;EE2IE,eAAe;AF3IH;;AAAd;;;;;;EAAc;;AAAd;CEuJC,aAAa;AFvJA;;AAAd;EE2JE,yBAAyB;AF3Jb;;AAAd;;;;;;EEoKE,kBAAkB;EAClB,oBAAoB;AFrKR;;AAAd;;;EAAc;;AAAd;EE8KE,cAAc;EACd,wBAAwB;AF/KZ;;AAAd;;;;;;EAAc;;AAAd;;;;;EE+LE,UAAU;EACV,oBAAoB;EACpB,cAAc;AFjMF;;AAAd;;;;;EAAc;;AAAd;;;;EE+ME,+GAAyI;AF/M7H;;AAAd;;;;;;;;;;;;;;;EAAc;;AAAd;;;;;;;;EE2OE,cAAc,EAAE,MAAM;EACtB,sBAAsB,EAAE,MAAM;AF5OlB;;AAAd;;;;;EAAc;;AAAd;;EEwPE,eAAe;EACf,YAAY;AFzPA;;AAAd;;EAAc;;AAAd;EEiQE,aAAa;AFjQD;;AGAd;CAAA,oBAAA;CAAA,oBAAA;CAAA,eAAA;CAAA,eAAA;CAAA,eAAA;CAAA,gBAAA;CAAA,gBAAA;CAAA,iNAAA;CAAA,uBAAA;CAAA,4DAAA;CAAA,mCAAA;CAAA,4BAAA;CAAA,uBAAA;CAAA,uCAAA;CAAA,6CAAA;CAAA,2CAAA;CAAA,4CAAA;CAAA,6CAAA;CAAA,yCAAA;CAAA,2CAAA;CAAA,wCAAA;CAAA,8CAAA;CAAA,uLAAA;CAAA,gDAAA;CAAA,sDAAA;CAAA,oDAAA;CAAA,qDAAA;CAAA,sDAAA;CAAA,kDAAA;CAAA,mDAAA;CAAA,oDAAA;CAAA,iDAAA;CAAA;CAAA;AHCA;CGDA;AHCoB;AAApB;;CGDA;EAAA;EAAA;AHCoB;AAApB;;CGDA;EAAA;EAAA;AHCoB;AAApB;;CGDA;EAAA;EAAA;AHCoB;AAApB;;CGDA;EAAA;EAAA;AHCoB;AAApB;;CGDA;EAAA;EAAA;AHCoB;AACpB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA,SAAA;CAAA,WAAA;CAAA,YAAA;CAAA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA,iBAAA;CAAA;AHEmB;AAAnB;CGFA,kBAAA;CAAA;AHEmB;AAAnB;CGFA,iBAAA;CAAA;AHEmB;AAAnB;CGFA,mBAAA;CAAA;AHEmB;AAAnB;CGFA,mBAAA;CAAA;AHEmB;AAAnB;CGFA,oBAAA;CAAA;AHEmB;AAAnB;CGFA,oBAAA;CAAA;AHEmB;AAAnB;CGFA,iBAAA;CAAA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA,kBAAA;CAAA;AHEmB;AAAnB;CGFA,kBAAA;CAAA;AHEmB;AAAnB;CGFA,oBAAA;CAAA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA,wBAAA;CAAA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA,0BAAA;IAAA,uBAAA;SAAA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA,wBAAA;CAAA,6DAAA;CAAA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA,uBAAA;CAAA;AHEmB;AAAnB;CGFA,uBAAA;CAAA;AHEmB;AAAnB;CGFA,uBAAA;CAAA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA,mBAAA;CAAA;AHEmB;AAAnB;CGFA,mBAAA;CAAA;AHEmB;AAAnB;CGFA,mBAAA;CAAA;AHEmB;AAAnB;CGFA,mBAAA;CAAA;AHEmB;AAAnB;CGFA,mBAAA;CAAA;AHEmB;AAAnB;CGFA,mBAAA;CAAA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA,qBAAA;IAAA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA,mBAAA;CAAA;AHEmB;AAAnB;CGFA,kBAAA;CAAA;AHEmB;AAAnB;CGFA,mBAAA;CAAA;AHEmB;AAAnB;CGFA,kBAAA;CAAA;AHEmB;AAAnB;CGFA,sBAAA;CAAA;AHEmB;AAAnB;CGFA,oBAAA;CAAA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA,oBAAA;CAAA;AHEmB;AAAnB;CGFA,mBAAA;CAAA;AHEmB;AAAnB;CGFA,kBAAA;CAAA;AHEmB;AAAnB;CGFA,kBAAA;CAAA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA,sBAAA;CAAA;AHEmB;AAAnB;CGFA,mBAAA;CAAA;AHEmB;AAAnB;CGFA,sBAAA;CAAA;AHEmB;AAAnB;CGFA,oBAAA;CAAA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA,oBAAA;CAAA;AHEmB;AAAnB;CGFA,mBAAA;CAAA;AHEmB;AAAnB;CGFA,oBAAA;CAAA;AHEmB;AAAnB;CGFA,gBAAA;CAAA;AHEmB;AAAnB;CGFA,kBAAA;CAAA;AHEmB;AAAnB;CGFA,mBAAA;CAAA;AHEmB;AAAnB;CGFA,mBAAA;CAAA;AHEmB;AAAnB;CGFA,gBAAA;CAAA;AHEmB;AAAnB;CGFA,kBAAA;CAAA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA,qBAAA;CAAA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA,6EAAA;CAAA;AHEmB;AAAnB;CGFA,6CAAA;CAAA;AHEmB;AAAnB;CGFA;AHEmB;AAAnB;CGFA,+CAAA;CAAA,mDAAA;SAAA;AHEmB;;AAEnB;EACE,oBAAoB;EACpB,4CAAiD;EACjD,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,4CAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,2BAA2B;EAC3B,gCAAgC;EAChC,kCAAkC;EAClC,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,eAAe;AACjB;;;;AAIA;EACE,2BAA2B;EAC3B,eAAe;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,wCAAwC;EACxC,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,4BAA4B;EAC5B,gBAAgB;;AAElB;;;AAJA;EACE,4BAA4B;EAC5B,gBAAgB;;AAElB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AA1FA;CGAA,uBAAA;CAAA;AH4FA;;AA5FA;CGAA,qBAAA;CAAA;AH4FA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@font-face {\n  font-family: Manrope;\n  src: url('./fonts/Manrope-VariableFont_wght.ttf');\n  font-weight: 100 900;\n  font-stretch: 50% 200%;\n}\n\n@font-face {\n  font-family: Poppins;\n  src: url(\"./fonts/Poppins-Medium.ttf\");\n  font-weight: 500;\n}\n\n:root {\n  --primary: #514BFF;\n  --on-primary: #FFFFFF;\n  --secondary: #FFA96F;\n  --on-secondary: #FFFFFF;\n  --background-color: #FFFFFF;\n  --background-color-dark: #F2F2F2;\n  --background-color-darker: #EBEBEB;\n  --text-color: #1E1E1E; \n  --text-color-alt: #1E1E1E99;\n  --text-color-grey: #777777;\n  --input-field-color: #F2F2F2;\n  --alt-button-color: #F6F6F6;\n  --black-button-color: #130F26;\n  --grey: #C8C8C8;\n}\n\n\n\nhtml * {\n  font-family: Manrope, Arial;\n  font-size: 1rem;\n  color: var(--text-color)\n}\n\ninput[type=text], input[type=password], select {\n  width: 20.875rem;\n  height: 3.3125rem;\n  flex-shrink: 0;\n  border-radius: 0.875rem; \n  background: var(--background-color-dark);\n  font-weight: 600;\n  box-sizing: border-box;\n  padding: 1rem 1.31rem 0.94rem 1.31rem;\n}\n\nh1 {\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\nh4 {\n  font-weight: 500;\n}\n\n.grey {\n  color: var(--text-color-grey);\n}\n\n\ninput[type=text]::placeholder, input[type=password]::placeholder {\n  color: var(--text-color-alt);\n  font-weight: 400;\n\n}\n\ninput[type=\"checkbox\"] {\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 0.375rem; \n  flex-shrink: 0;\n  color: var(--background-color-dark);\n  accent-color: var(--primary);\n}\n\na:link.always-active, a:visited.always-active {\n  color: var(--primary);\n  font-weight: 600;\n}\n\n.heading {\n  font-weight: 600;\n  font-size: 20px;\n}\n\n","/*! modern-normalize v1.1.0 | MIT License | https://github.com/sindresorhus/modern-normalize */\n\n/*\nDocument\n========\n*/\n\n/**\nUse a better box model (opinionated).\n*/\n\n*,\n::before,\n::after {\n\tbox-sizing: border-box;\n}\n\n/**\nUse a more readable tab size (opinionated).\n*/\n\nhtml {\n\t-moz-tab-size: 4;\n\ttab-size: 4;\n}\n\n/**\n1. Correct the line height in all browsers.\n2. Prevent adjustments of font size after orientation changes in iOS.\n*/\n\nhtml {\n\tline-height: 1.15; /* 1 */\n\t-webkit-text-size-adjust: 100%; /* 2 */\n}\n\n/*\nSections\n========\n*/\n\n/**\nRemove the margin in all browsers.\n*/\n\nbody {\n\tmargin: 0;\n}\n\n/**\nImprove consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)\n*/\n\nbody {\n\tfont-family:\n\t\tsystem-ui,\n\t\t-apple-system, /* Firefox supports this but not yet `system-ui` */\n\t\t'Segoe UI',\n\t\tRoboto,\n\t\tHelvetica,\n\t\tArial,\n\t\tsans-serif,\n\t\t'Apple Color Emoji',\n\t\t'Segoe UI Emoji';\n}\n\n/*\nGrouping content\n================\n*/\n\n/**\n1. Add the correct height in Firefox.\n2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n*/\n\nhr {\n\theight: 0; /* 1 */\n\tcolor: inherit; /* 2 */\n}\n\n/*\nText-level semantics\n====================\n*/\n\n/**\nAdd the correct text decoration in Chrome, Edge, and Safari.\n*/\n\nabbr[title] {\n\ttext-decoration: underline dotted;\n}\n\n/**\nAdd the correct font weight in Edge and Safari.\n*/\n\nb,\nstrong {\n\tfont-weight: bolder;\n}\n\n/**\n1. Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)\n2. Correct the odd 'em' font sizing in all browsers.\n*/\n\ncode,\nkbd,\nsamp,\npre {\n\tfont-family:\n\t\tui-monospace,\n\t\tSFMono-Regular,\n\t\tConsolas,\n\t\t'Liberation Mono',\n\t\tMenlo,\n\t\tmonospace; /* 1 */\n\tfont-size: 1em; /* 2 */\n}\n\n/**\nAdd the correct font size in all browsers.\n*/\n\nsmall {\n\tfont-size: 80%;\n}\n\n/**\nPrevent 'sub' and 'sup' elements from affecting the line height in all browsers.\n*/\n\nsub,\nsup {\n\tfont-size: 75%;\n\tline-height: 0;\n\tposition: relative;\n\tvertical-align: baseline;\n}\n\nsub {\n\tbottom: -0.25em;\n}\n\nsup {\n\ttop: -0.5em;\n}\n\n/*\nTabular data\n============\n*/\n\n/**\n1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n*/\n\ntable {\n\ttext-indent: 0; /* 1 */\n\tborder-color: inherit; /* 2 */\n}\n\n/*\nForms\n=====\n*/\n\n/**\n1. Change the font styles in all browsers.\n2. Remove the margin in Firefox and Safari.\n*/\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n\tfont-family: inherit; /* 1 */\n\tfont-size: 100%; /* 1 */\n\tline-height: 1.15; /* 1 */\n\tmargin: 0; /* 2 */\n}\n\n/**\nRemove the inheritance of text transform in Edge and Firefox.\n1. Remove the inheritance of text transform in Firefox.\n*/\n\nbutton,\nselect { /* 1 */\n\ttext-transform: none;\n}\n\n/**\nCorrect the inability to style clickable types in iOS and Safari.\n*/\n\nbutton,\n[type='button'],\n[type='reset'],\n[type='submit'] {\n\t-webkit-appearance: button;\n}\n\n/**\nRemove the inner border and padding in Firefox.\n*/\n\n::-moz-focus-inner {\n\tborder-style: none;\n\tpadding: 0;\n}\n\n/**\nRestore the focus styles unset by the previous rule.\n*/\n\n:-moz-focusring {\n\toutline: 1px dotted ButtonText;\n}\n\n/**\nRemove the additional ':invalid' styles in Firefox.\nSee: https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737\n*/\n\n:-moz-ui-invalid {\n\tbox-shadow: none;\n}\n\n/**\nRemove the padding so developers are not caught out when they zero out 'fieldset' elements in all browsers.\n*/\n\nlegend {\n\tpadding: 0;\n}\n\n/**\nAdd the correct vertical alignment in Chrome and Firefox.\n*/\n\nprogress {\n\tvertical-align: baseline;\n}\n\n/**\nCorrect the cursor style of increment and decrement buttons in Safari.\n*/\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n\theight: auto;\n}\n\n/**\n1. Correct the odd appearance in Chrome and Safari.\n2. Correct the outline style in Safari.\n*/\n\n[type='search'] {\n\t-webkit-appearance: textfield; /* 1 */\n\toutline-offset: -2px; /* 2 */\n}\n\n/**\nRemove the inner padding in Chrome and Safari on macOS.\n*/\n\n::-webkit-search-decoration {\n\t-webkit-appearance: none;\n}\n\n/**\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Change font properties to 'inherit' in Safari.\n*/\n\n::-webkit-file-upload-button {\n\t-webkit-appearance: button; /* 1 */\n\tfont: inherit; /* 2 */\n}\n\n/*\nInteractive\n===========\n*/\n\n/*\nAdd the correct display in Chrome and Safari.\n*/\n\nsummary {\n\tdisplay: list-item;\n}\n","/**\n * Manually forked from SUIT CSS Base: https://github.com/suitcss/base\n * A thin layer on top of normalize.css that provides a starting point more\n * suitable for web applications.\n */\n\n/**\n * Removes the default spacing and border for appropriate elements.\n */\n\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\n\nbutton {\n  background-color: transparent;\n  background-image: none;\n}\n\nfieldset {\n  margin: 0;\n  padding: 0;\n}\n\nol,\nul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/**\n * Tailwind custom reset styles\n */\n\n/**\n * 1. Use the user's configured `sans` font-family (with Tailwind's default\n *    sans-serif font stack as a fallback) as a sane default.\n * 2. Use Tailwind's default \"normal\" line-height so the user isn't forced\n *    to override it to ensure consistency even when using the default theme.\n */\n\nhtml {\n  font-family: theme('fontFamily.sans', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"); /* 1 */\n  line-height: 1.5; /* 2 */\n}\n\n\n/**\n * Inherit font-family and line-height from `html` so users can set them as\n * a class directly on the `html` element.\n */\n\nbody {\n  font-family: inherit;\n  line-height: inherit;\n}\n\n/**\n * 1. Prevent padding and border from affecting element width.\n *\n *    We used to set this in the html element and inherit from\n *    the parent element for everything else. This caused issues\n *    in shadow-dom-enhanced elements like <details> where the content\n *    is wrapped by a div with box-sizing set to `content-box`.\n *\n *    https://github.com/mozdevs/cssremedy/issues/4\n *\n *\n * 2. Allow adding a border to an element by just adding a border-width.\n *\n *    By default, the way the browser specifies that an element should have no\n *    border is by setting it's border-style to `none` in the user-agent\n *    stylesheet.\n *\n *    In order to easily add borders to elements by just setting the `border-width`\n *    property, we change the default border-style for all elements to `solid`, and\n *    use border-width to hide them instead. This way our `border` utilities only\n *    need to set the `border-width` property instead of the entire `border`\n *    shorthand, making our border utilities much more straightforward to compose.\n *\n *    https://github.com/tailwindcss/tailwindcss/pull/116\n */\n\n*,\n::before,\n::after {\n  box-sizing: border-box; /* 1 */\n  border-width: 0; /* 2 */\n  border-style: solid; /* 2 */\n  border-color: currentColor; /* 2 */\n}\n\n/*\n * Ensure horizontal rules are visible by default\n */\n\nhr {\n  border-top-width: 1px;\n}\n\n/**\n * Undo the `border-style: none` reset that Normalize applies to images so that\n * our `border-{width}` utilities have the expected effect.\n *\n * The Normalize reset is unnecessary for us since we default the border-width\n * to 0 on all elements.\n *\n * https://github.com/tailwindcss/tailwindcss/issues/362\n */\n\nimg {\n  border-style: solid;\n}\n\ntextarea {\n  resize: vertical;\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 1;\n  color: theme('colors.gray.400', #a1a1aa);\n}\n\nbutton,\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n/**\n * Override legacy focus reset from Normalize with modern Firefox focus styles.\n *\n * This is actually an improvement over the new defaults in Firefox in our testing,\n * as it triggers the better focus styles even for links, which still use a dotted\n * outline in Firefox by default.\n */\n \n:-moz-focusring {\n\toutline: auto;\n}\n\ntable {\n  border-collapse: collapse;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n/**\n * Reset links to optimize for opt-in styling instead of\n * opt-out.\n */\n\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\n/**\n * Reset form element properties that are easy to forget to\n * style explicitly so you don't inadvertently introduce\n * styles that deviate from your design system. These styles\n * supplement a partial reset that is already applied by\n * normalize.css.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  padding: 0;\n  line-height: inherit;\n  color: inherit;\n}\n\n/**\n * Use the configured 'mono' font family for elements that\n * are expected to be rendered with a monospace font, falling\n * back to the system monospace stack if there is no configured\n * 'mono' font family.\n */\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: theme('fontFamily.mono', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace);\n}\n\n/**\n * 1. Make replaced elements `display: block` by default as that's\n *    the behavior you want almost all of the time. Inspired by\n *    CSS Remedy, with `svg` added as well.\n *\n *    https://github.com/mozdevs/cssremedy/issues/14\n * \n * 2. Add `vertical-align: middle` to align replaced elements more\n *    sensibly by default when overriding `display` by adding a\n *    utility like `inline`.\n *\n *    This can trigger a poorly considered linting error in some\n *    tools but is included by design.\n * \n *    https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210\n */\n\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block; /* 1 */\n  vertical-align: middle; /* 2 */\n}\n\n/**\n * Constrain images and videos to the parent width and preserve\n * their intrinsic aspect ratio.\n *\n * https://github.com/mozdevs/cssremedy/issues/14\n */\n\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n\n/**\n * Ensure the default browser behavior of the `hidden` attribute.\n */\n\n[hidden] {\n  display: none;\n}\n",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
